import {
  RecomplyPermittedUseLabel,
  ComplianceTakeBackButton,
  CompliancePreviousPageButton,
} from '@/compliance/molecules';
import { Text, styled } from '@/theme/index';

const RecomplyPageContainer = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(1.5)} auto`,
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '50%',
  },
}));

/**
 * This page should show once the user recomply and wants to use the
 * account without criminal, traffic, bankruptcy, judgement, and lien data.
 * It is important to say that the account is reactivated.
 */
export function ComplianceRecomplyPage() {
  return (
    <>
      <CompliancePreviousPageButton />

      <RecomplyPageContainer>
        <RecomplyPermittedUseLabel />

        <Text variant="h1" mt={1.5} mb={2.5}>
          Thank you for acknowledging compliance with BeenVerified’s Terms of
          Service
        </Text>
        <Text mt={2.5}>
          Per your request, your account is now reactivated without criminal,
          traffic, bankruptcy, judgement, and lien data.
        </Text>

        <ComplianceTakeBackButton />
      </RecomplyPageContainer>
    </>
  );
}
